import Vue from 'vue';
import App from './App.vue';
import router from './router';
import './static/public.less'; //引入公共样式
import ViewUI from 'view-design';
import 'view-design/dist/styles/iview.css';
import store from './store';
// 自己封装的axios
import http from './config/http';
import axios from 'axios';
// 图片缩放
import Viewer from 'v-viewer';
import 'viewerjs/dist/viewer.css';
import { directive as onClickaway } from 'vue-clickaway2';
// 引入组件
import Vcomp from './config/vcoms';
// 打印插件
import Print from 'vue-print-nb';
Vue.use(Print);
// 引入指令
import Directive from "./config/directive";
Vue.use(Directive)

Vue.directive('on-clickaway', onClickaway);

Vue.use(Viewer, {
  defaultOptions: {
    zIndex: 9999
  }
});

Vue.use(Vcomp);

Viewer.setDefaults({
  Options: {
    inline: false, // 启用 inline 模式
    button: true, // 显示右上角关闭按钮
    navbar: true, // 显示缩略图导航
    title: true, // 显示当前图片的标题
    toolbar: true, // 显示工具栏
    tooltip: true, // 显示缩放百分比
    movable: true, // 图片是否可移动
    zoomable: true, // 图片是否可缩放
    rotatable: true, // 图片是否可旋转
    scalable: true, // 图片是否可翻转
    transition: true, // 使用 CSS3 过度
    fullscreen: false, // 播放时是否全屏
    keyboard: true, // 是否支持键盘
    url: 'data-source' // 设置大图片的 url
  }
});

// 图片上传地址
// let baseUrl = 'http://192.168.2.226:9023/zzsoft/openApi/v1/file/modeImpFile.fix'; // 测试
// let baseUrl = "http://172.16.4.239:8008/zzsoft/openApi/v1/file/modeImpFile.fix"; // 辉县地区测试
let baseUrl = 'https://openapi.zzkyt.cn/zzsoft/openApi/v1/file/modeImpFile.fix'; // 生产地址
// let baseUrl = "https://openapi.lnkyt.cn/zzsoft/openApi/v1/file/modeImpFile.fix"; // 新测试地址
// 手机上传链接
// let mobilePhone = 'http://192.168.2.227:8006/#/'; // 测试
// let mobilePhone = 'http://cfw.zzkyt.cn/#/'; // 开发
let mobilePhone = 'http://fw.zzkyt.cn/#/'; // 生产
// let mobilePhone = 'http://192.168.2.43:8080/#/';
// 图片url地址
let fileUrl = 'http://file.zzkyt.cn:8888';

Vue.prototype.$fileUrl = fileUrl;
Vue.prototype.$mobilePhone = mobilePhone;
Vue.prototype.$baseUrl = baseUrl;
Vue.prototype.$axios = axios;
Vue.use(ViewUI);
Vue.prototype.$http = http;
Vue.config.productionTip = false;
// 时间处理函数
function timeChange(time) {
  if (time) {
    let d = new Date(time);
    let month, day, hour, minute, second;
    if (d.getMonth() + 1 < 10) {
      month = '0' + (d.getMonth() + 1);
    } else {
      month = d.getMonth() + 1;
    }
    if (d.getDate() < 10) {
      day = '0' + d.getDate();
    } else {
      day = d.getDate();
    }
    if (d.getHours() < 10) {
      hour = '0' + d.getHours();
    } else {
      hour = d.getHours();
    }
    if (d.getMinutes() < 10) {
      minute = '0' + d.getMinutes();
    } else {
      minute = d.getMinutes();
    }
    if (d.getSeconds() < 10) {
      second = '0' + d.getSeconds();
    } else {
      second = d.getSeconds();
    }
    let dateTime = d.getFullYear() + '-' + month + '-' + day;
    return dateTime;
  }
}
Vue.prototype.$timeChange = timeChange;
new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount('#app');
